export default "__VITE_ASSET__08D1gMX5__"